// extracted by mini-css-extract-plugin
export var button = "_kq-0";
export var donut = "_kq-1";
export var donutFill = "_kq-3";
export var donutTrack = "_kq-2";